export default __webpack_public_path__ + "static/media/play-circle 1.38e94087.svg";